import { INVALIDATE as AUTH_INVALIDATE } from '@/store/actions/auth';
import { FETCH, initialState } from '@/store/actions/challenges';

const itemsSort = (a, b) => {
    return a.startDate > b.startDate;
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH: {
            if (action.status === status.SUCCESS && !!action.data) {
                const items = action.data;
                return {
                    data: items.sort(itemsSort),
                    selected: {},
                    loading: false
                };
            }
            return { ...state, loading: action.status === status.REQUEST };
        }

        case AUTH_INVALIDATE:
        default: {
            return state;
        }
    }
};
